/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from 'zod';
import { areaOfStudySchema } from './area-of-study-schema';
import { candidateSchema } from './candidate-schema';
import { lawSchoolSchema } from './law-school-schema';
import { EducationDegree } from "../enums";

export const educationSchema: z.AnyZodObject = z.object({
  areaOfStudy: z.lazy(() => areaOfStudySchema).nullish(),
  areaOfStudyId: z.string().uuid().nullish(),
  candidate: z.lazy(() => candidateSchema).nullish(),
  candidateId: z.string().uuid().nullish(),
  createdAt: z.string().datetime().nullish(),
  degree: z.nativeEnum(EducationDegree).nullish(),
  id: z.string().uuid(),
  institution: z.string().nullish(),
  isPrimary: z.boolean().nullish(),
  lastUpdatedBy: z.string().uuid().nullish(),
  lawSchool: z.lazy(() => lawSchoolSchema).nullish(),
  lawSchoolId: z.string().uuid().nullish(),
  updatedAt: z.string().datetime().nullish(),
  yearAwarded: z.number().int().nullish(),
});

export type Education = z.infer<typeof educationSchema>;
